import { getAccountsQueryConfig } from '@api/lendingAPI/queryConfigs';
import { logError, TAGS } from '@iwLogger/IwDataDogLogger';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';

export const useRCFNextRepayment = (accountId: string) => {
    const stateKey = useStateKey();
    const { data: account } = useQuery({
        ...getAccountsQueryConfig(stateKey),
        select: ({ data }) =>
            data.accounts.find((account) => account.account_id === accountId),
        suspense: true
    });

    if (!account) {
        const errorMessage = `useRCFNextRepayment - RCF Account with id ${accountId} not found`;
        logError(errorMessage, { tags: TAGS.DE_LENDING });
        throw new Error(errorMessage);
    }

    // No scheduled_payments means the customer activated the RCF but hasn't drawn down yet
    if (!account.scheduled_payments) {
        return null;
    }

    const { schedule, summary: scheduleSummary } = account.scheduled_payments;
    const nextRepayment = scheduleSummary!.simplified_schedule!.next_repayment!;
    const outstandingBalance = account.pending_balance!.total!;

    return {
        schedule: schedule!,
        scheduleSummary: scheduleSummary!,
        outstandingBalance,
        nextRepaymentDate: nextRepayment.date,
        nextRepaymentAmount: nextRepayment.amount
    };
};
